import { NgModule, ModuleWithProviders } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AlertService } from './alert.service';

@NgModule({
  imports: [
    TranslateModule.forChild()
  ]
})
export class AlertModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: AlertModule,
      providers: [AlertService]
    };
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/modules/alert/alert.module.ts